<template>
  <div
    class="order-type-wrap line-btn sm mb16"
    v-if="orderTypes.length > 0"
    :style="{
      borderColor: getMainComponentStyle?.borderColor,
    }"
    :allowedOrderType="allowedOrderType"
  >
    <div
      class="order-type-btn btn-1 color-slaty"
      v-for="(item, i) in orderTypes"
      @click="handleOrderTypeClick($event, item, i)"
      :class="[
        currentOrderType == item.orderType ? 'active' : '',
        item.orderType === 'IRCTC' && 'hide',
      ]"
      :style="{
        backgroundColor:
          currentOrderType == item.orderType
            ? getMainComponentStyle?.selectedOrderTypeTabColor
            : getMainComponentStyle?.unselectedOrderTypeTabColor,
        borderLeftColor:
          currentOrderType != item.orderType
            ? getMainComponentStyle?.borderColor
            : '',
      }"
      :key="i"
    >
      <div
        class="fs-12 lh16"
        :style="{
          color:
            currentOrderType == item.orderType
              ? getMainComponentStyle?.orderTypeSelectedTitleColor
              : getMainComponentStyle?.orderTypeTabTitleColor,
        }"
      >
        {{ item.title }}
      </div>
      <div
        class="fs-11 lh14 normal color-grey"
        :style="{
          color:
            currentOrderType == item.orderType
              ? getMainComponentStyle?.orderTypeSelectedSubTitleColor
              : getMainComponentStyle?.orderTypeTabTitleColor,
        }"
      >
        <i
          v-if="is20MinDel && currentOrderType == 'D' && item?.orderType == 'D'"
          class="jfi-flash fs-11"
        ></i>
        {{ getSubTitle(item) }}
      </div>
    </div>
  </div>
</template>

<script>
import { imgBaseUrl, v2PwaBasePath } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import localStorageFunc from "../helpers/localStorageFunc";
import userActivityTracking from "../helpers/UserActivityTracking";
import PageNames from "../config/pageNames";
import amplitude from "amplitude-js";
import { ORDER_TYPE } from "../helpers/paymentConstants";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";

export default {
  name: "OrderTypeTabs",
  components: {},
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      imgBaseUrl: imgBaseUrl,
      orderTypes: [],
      timeServiceGuarantee: "",
      noSgCaseCmsString: "",
      modulePropsData: {},
      orderTypesQR: [],
    };
  },
  mounted() {
    this.orderTypes = JSON.parse(this.dataResults);
    this.orderTypesQR = this.orderTypes;
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.noSgCaseCmsString = this.modulePropsData?.noSgTextOnTab || "NOW";

    //Amplitude impression event load
    const eventObj = Utility.amplitudeEventObj(
      "impression",
      "order type section",
      "2",
      {},
    );
    setEvents("amplitude", "Impression", eventObj);
  },
  methods: {
    handleOrderTypeClick(event, item, index) {
      userActivityTracking.deliveryType(item, 0);
      //Amplitude click event load
      const category = {
        D: "delivery",
        P: "takeaway",
        DINEIN: "dine-in",
        IRCTC: "delivery to train",
      }[item.orderType];
      const preEventObj = { positionWithinSection: index + 1, category };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "order type section",
        "2",
        preEventObj,
      );
      setEvents("amplitude", "Click", eventObj);
      if (this.qrOrderFlow) {
        localStorageFunc.setDeliveryType(item.orderType);
        this.$store.commit(
          keyMapsMutation.LOAD_CURRENT_ORDER_TYPE,
          item.orderType,
        );
        const lastLocationNew = Utility.tryJsonParse(
          localStorage.lastLocationNew,
        ) || [{}];

        const recentLastLocation = lastLocationNew[0]?.recent;
        this.$store.commit(
          keyMapsMutation.UPDATE_HOME_PAGE_ADDRESS,
          recentLastLocation,
        );

        let tempObjLoc = lastLocationNew[0] || {};
        tempObjLoc["deliveryType"] = item.orderType;

        const updatedLastLocationNew = [...lastLocationNew];
        updatedLastLocationNew[0] = tempObjLoc;

        localStorage.lastLocationNew = JSON.stringify(updatedLastLocationNew);

        return;
      }
      let redirectUrl = Utility.redirectUrlForNonDeliveryOrderType(
        this.isTrueLocationDetected,
        item.orderType,
      );
      window.location.href = {
        D: `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}searchAddress?isFromHome=true`,
        P: `${v2PwaBasePath}/${redirectUrl}&isFromHome=true`,
        DINEIN: `${v2PwaBasePath}/${redirectUrl}&isFromHome=true`,
        IRCTC: `${v2PwaBasePath}/deliverOnTrain`,
        CURB: `${v2PwaBasePath}/${redirectUrl}&isFromHome=true`,
      }[item.orderType];
    },
    getSubTitle(item) {
      if (item.orderType == "D" && this.currentOrderType == "D") {
        let val = this.getOrderTypeDeliveryTime()?.value;
        let cmsValFlag = this.getOrderTypeDeliveryTime()?.cmsValFlag;

        if (val) {
          if (cmsValFlag) {
            val = this.getDeliveryETAValueFromCMS;
          } else {
            val = val + " Mins";
          }
          this.setUserProperty(
            "nghDeliveryTime",
            cmsValFlag ? this.getDeliveryETAValueFromCMS : parseInt(val),
          );
        } else {
          val = this.noSgCaseCmsString;
          this.setUserProperty("nghDeliveryTime", val);
        }

        localStorageFunc.setOrderTypeSubtitle({
          Delivery_Duration: val,
        });
        this.logMenuLoadEvent({
          deliveryDuration: val,
        });
        return val;
      } else if (
        item.orderType == "DINEIN" &&
        this.currentOrderType == "DINEIN"
      ) {
        const val = this.isTrueLocationDetected
          ? this.setOrderTypeDetails(item.orderType) || "___"
          : item.defaultSubtitle;
        if (val !== item.defaultSubtitle) {
          localStorageFunc.setOrderTypeSubtitle({
            Dinein_Distance: val,
          });
          this.logMenuLoadEvent({
            dineinDistance: val,
          });
        }
        return val;
      } else if (
        (item.orderType == "P" && this.currentOrderType == "P") ||
        (item.orderType == "CURB" && this.currentOrderType == "CURB")
      ) {
        const val = this.isTrueLocationDetected
          ? this.setOrderTypeDetails(item.orderType) || "___"
          : item.defaultSubtitle;
        if (val !== item.defaultSubtitle) {
          localStorageFunc.setOrderTypeSubtitle({
            Takeaway_Distance: val,
          });
          this.logMenuLoadEvent({
            takeawayDistance: val,
          });
        }
        return val;
      } else {
        if (item.orderType == "D") {
          const val =
            this.currentOrderType == "D"
              ? this.noSgCaseCmsString
              : item.defaultSubtitle;
          this.setUserProperty("nghDeliveryTime", val);
          return val;
        } else {
          return item.defaultSubtitle;
        }
      }
    },
    logMenuLoadEvent(value) {
      if (!this.getStoreDetails?.id) return;
      const previousEventFiredFor = localStorageFunc.getMenuLoadEventFiredFor();
      if (
        this.storeId !== previousEventFiredFor?.storeId ||
        this.currentOrderType !== previousEventFiredFor.orderType
      ) {
        const eventObj = Utility.amplitudeEventObj(
          "nghMenuLoad",
          PageNames.NEXTGEN_HOMEPAGE,
          undefined,
          value,
        );
        setEvents("amplitude", "nghMenuLoad", eventObj);
        localStorageFunc.setMenuLoadEventFiredFor({
          storeId: this.storeId,
          orderType: this.currentOrderType,
        });
      }
    },
    setOrderTypeDetails(orderType = "") {
      let msg = "";
      let cond_1 =
        this.getOrderDetailsFromLoc?.driveDistanceInKm !== undefined &&
        this.getMaxDistanceShown !== undefined &&
        this.getOrderDetailsFromLoc?.driveDistanceInKm &&
        this.getMaxDistanceShown
          ? true
          : false;
      let cond_2 =
        this.getOrderDetailsFromLoc?.aerialDistanceInKm !== undefined &&
        this.getMaxDistanceShown !== undefined &&
        this.getOrderDetailsFromLoc?.aerialDistanceInKm &&
        this.getMaxDistanceShown
          ? true
          : false;
      if (
        this.getStoreDetails?.latitude !== undefined &&
        this.getStoreDetails?.longitude !== undefined
      ) {
        if (
          cond_1 &&
          Math.abs(this.getOrderDetailsFromLoc?.driveDistanceInKm) > 0 &&
          Math.round(this.getMaxDistanceShown) >
            Math.abs(this.getOrderDetailsFromLoc?.driveDistanceInKm)
        ) {
          msg = `${Math.abs(
            this.getOrderDetailsFromLoc?.driveDistanceInKm,
          )} KM`;
        } else if (
          cond_1 &&
          Math.abs(this.getOrderDetailsFromLoc?.driveDistanceInKm) > 0 &&
          Math.round(this.getMaxDistanceShown) <
            Math.abs(this.getOrderDetailsFromLoc?.driveDistanceInKm)
        ) {
          msg = `${Math.round(this.getMaxDistanceShown)} + KM`;
        } else if (
          cond_1 &&
          Math.abs(this.getOrderDetailsFromLoc?.driveDistanceInKm) > 0 &&
          Math.abs(this.getOrderDetailsFromLoc?.driveDistanceInKm) < 1 &&
          this.getOrderDetailsFromLoc?.driveDistanceInKm !== ""
        ) {
          msg = `~ 100 meter`;
        } else {
          if (
            cond_2 &&
            Math.abs(this.getOrderDetailsFromLoc?.aerialDistanceInKm) > 0 &&
            Math.round(this.getMaxDistanceShown) >
              Math.abs(this.getOrderDetailsFromLoc?.aerialDistanceInKm)
          ) {
            msg = `${Math.abs(
              this.getOrderDetailsFromLoc?.aerialDistanceInKm,
            )} KM`;
          } else if (
            cond_2 &&
            Math.abs(this.getOrderDetailsFromLoc?.aerialDistanceInKm) > 0 &&
            Math.round(this.getMaxDistanceShown) <
              Math.abs(this.getOrderDetailsFromLoc?.aerialDistanceInKm)
          ) {
            msg = `${Math.round(this.getMaxDistanceShown)} + KM`;
          } else if (
            cond_2 &&
            Math.abs(this.getOrderDetailsFromLoc?.aerialDistanceInKm) > 0 &&
            Math.abs(this.getOrderDetailsFromLoc?.aerialDistanceInKm) < 1 &&
            this.getOrderDetailsFromLoc?.aerialDistanceInKm !== ""
          ) {
            msg = `~ 100 meter`;
          }
        }
      }
      if (!msg && this.qrOrderFlow && orderType != ORDER_TYPE.DELIVERY) {
        if (!this.modulePropsData?.qrOrderTypeSubDefaultTitle) {
          msg = "At store";
        } else {
          msg = this.modulePropsData?.qrOrderTypeSubDefaultTitle || "At store";
        }
      }
      return msg;
    },
    setUserProperty(key, val) {
      const { timeServiceGuarantee = {} } = this.getStoreDetails;
      const { type = "", deliveryETA = "" } = timeServiceGuarantee;
      let actualDeliveryETA = parseInt(deliveryETA);

      amplitude.setUserProperties({
        [key]: val,
      });
      amplitude.setUserProperties({
        ["nghDG"]: actualDeliveryETA ? actualDeliveryETA : "-1",
      });
      amplitude.setUserProperties({
        ["nghSG"]: type ? type : "-1",
      });
    },
    getOrderTypeDeliveryTime() {
      const { timeServiceGuarantee = {} } = this.getStoreDetails;
      const { type = "", deliveryETA = "" } = timeServiceGuarantee;
      let actualDeliveryETA = parseInt(deliveryETA) || 0;

      if (this.isTrueLocationDetected && !this.getLocationSource) {
        if (type !== undefined && Number(type)) {
          return {
            value: type,
            cmsValFlag: false,
          };
        } else if (actualDeliveryETA && Number(actualDeliveryETA)) {
          return {
            value: actualDeliveryETA,
            cmsValFlag: true,
          };
        } else {
          return {
            value: false,
            cmsValFlag: false,
          };
        }
      } else {
        return {
          value: false,
          cmsValFlag: false,
        };
      }
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    currentOrderType() {
      // if currentOrderType is not curb then remove curb else remove 'P'
      if (this.$store.state.User.currentOrderType) {
        if (this.$store.state.User.currentOrderType !== "CURB") {
          this.orderTypes.forEach((item, index) => {
            if (item.orderType === "CURB") {
              this.orderTypes.splice(index, 1);
            }
          });
        } else {
          this.orderTypes.forEach((item, index) => {
            if (item.orderType === "P") {
              this.orderTypes.splice(index, 1);
            }
          });
        }
      }
      return this.$store.state.User.currentOrderType;
    },
    isTrueLocationDetected() {
      const data = this.$store.state.Location.isTrueLocationDetected;
      return this.qrOrderFlow
        ? true
        : this.$store.state.Location.isTrueLocationDetected;
    },
    getStoreDetails() {
      return (
        this.$store.state.Location?.storeDetails !== undefined &&
        this.$store.state.Location.storeDetails
      );
    },
    getOrderDetailsFromLoc() {
      return localStorageFunc.getDeliveryTypeStationData() || {};
    },
    getMaxDistanceShown() {
      return window?._siteProps_?.props?.maxShownDistance || 0;
    },
    is20MinDel() {
      const { timeServiceGuarantee = {} } = this.getStoreDetails;
      const { type = "" } = timeServiceGuarantee;
      if (
        !this.getLocationSource &&
        this.isTrueLocationDetected &&
        type &&
        Number(type) &&
        Number(type) < 30
      ) {
        return true;
      } else {
        return false;
      }
    },
    storeId() {
      return localStorageFunc.storeId();
    },
    getDeliveryETAValueFromCMS() {
      return (
        this.$store.state.DynamicWidget.deliveryTabValue ||
        this.noSgCaseCmsString
      );
    },
    getLocationSource() {
      return this.$store.state.Location?.locationType?.toLowerCase() == "ip";
    },
    getMainComponentStyle() {
      let orderTypeSelectedTitleColor =
        this.modulePropsData?.orderTypeSelectedTitleColor;
      let orderTypeTabTitleColor = this.modulePropsData?.orderTypeTabTitleColor;
      let borderColor = this.modulePropsData?.borderColor;
      let orderTypeTabSubtitleColor = this.orderTypeTabSubtitleColor;
      let unselectedOrderTypeTabColor =
        this.modulePropsData?.unselectedOrderTypeTabColor;
      let orderTypeSelectedSubTitleColor =
        this.modulePropsData?.orderTypeSelectedSubTitleColor;
      let selectedOrderTypeTabColor =
        this.modulePropsData?.selectedOrderTypeTabColor;

      return {
        orderTypeSelectedTitleColor: orderTypeSelectedTitleColor,
        orderTypeTabTitleColor: orderTypeTabTitleColor,
        borderColor: borderColor,
        orderTypeTabSubtitleColor: orderTypeTabSubtitleColor,
        orderTypeSelectedSubTitleColor: orderTypeSelectedSubTitleColor,
        unselectedOrderTypeTabColor: unselectedOrderTypeTabColor,
        selectedOrderTypeTabColor: selectedOrderTypeTabColor,
      };
    },
    qrOrderFlow() {
      return this.$store.state.Auth.qrOrder;
    },
    allowedOrderType() {
      if (!this.qrOrderFlow) {
        this.orderTypes = this.orderTypesQR;
        return true;
      }
      const { allowedDeliveryTypeCodes = [ORDER_TYPE.DINEIN] } =
        this.getStoreDetails;

      let result = this.orderTypesQR;
      const set = new Set(
        allowedDeliveryTypeCodes.map((item) => item.toLowerCase()),
      );
      result =
        allowedDeliveryTypeCodes.length &&
        result.filter((item) => set.has(item?.orderType?.toLowerCase()));

      const hideDelivery =
        window._siteProps_.props?.hide_delivery_tab_qr === "true";
      if (hideDelivery) {
        result = result.filter(
          (item) =>
            item.orderType?.toLowerCase() !== ORDER_TYPE.DELIVERY.toLowerCase(),
        );
      }
      this.orderTypes = result;
      return false;
    },
  },
};
</script>
